import { LANGUAGE_OPTIONS } from "neetocommons/constants";
import {
  User,
  UserAdd,
  UserCircle,
  UserRemove,
  UserSettings,
  CustomDomain,
  ApiKeys,
} from "neetoicons";
import {
  Apple,
  GoogleCalendar,
  GoogleMeet,
  Outlook,
  Slack,
  Stripe,
  StripeTypeface,
  Teams,
  Twilio,
  Zoom,
} from "neetoicons/misc";
import { indexBy, prop } from "ramda";

export const AUDIT_LOGS_QUERY_KEY = "audit-logs";
export const COUNTRIES_LIST_QUERY_KEY = "countries-list"; // Same key as that used in "neeto-team-members" for cache reuse.
export const PERMISSIONS_LIST_QUERY_KEY = "neeto-team-members-permissions"; // Same key as that used in "neeto-team-members" for cache reuse.

export const ACTIONS = {
  INVITED_USERS: "invitedUsers",
  USER_SIGNED_UP: "userSignedUp",
  UPDATED_USER: "updatedUser",
  BULK_UPDATE_USERS: "bulkUpdateUsers",
  UPDATED_USER_PROFILE: "updatedUserProfile",
  CREATED_ROLE: "createdRole",
  UPDATED_ROLE: "updatedRole",
  DELETED_ROLE: "deletedRole",
  INTEGRATION_CONNECTED: "integration.connected",
  INTEGRATION_DISCONNECTED: "integration.disconnected",
  INTEGRATION_DISCONNECTED_BY_PROVIDER: "integration.disconnectedByProvider",
  CONNECTED_STRIPE_ACCOUNT: "connectedStripeAccount",
  DISCONNECTED_STRIPE_ACCOUNT: "disconnectedStripeAccount",
  CONNECTED_ZOOM_INTEGRATION: "connectedZoomIntegration",
  DISCONNECTED_ZOOM_INTEGRATION: "disconnectedZoomIntegration",
  CONNECTED_CUSTOM_DOMAIN: "connectedCustomDomain",
  CREATED_API_KEY: "createdApiKey",
  DELETED_API_KEY: "deletedApiKey",
  UPDATED_API_KEY: "updatedApiKey",
};

export const ADDITIONAL_DETAILS_KEYS = {
  ACTION: "action",
  PERFORMED_BY: "performedBy",
  PERFORMED_AT: "performedAt",
  PRODUCT: "product",
};

export const AUDIT_ICON_MAP = {
  [ACTIONS.INVITED_USERS]: UserCircle,
  [ACTIONS.USER_SIGNED_UP]: UserAdd,
  [ACTIONS.UPDATED_USER]: User,
  [ACTIONS.BULK_UPDATE_USERS]: User,
  [ACTIONS.UPDATED_USER_PROFILE]: UserSettings,
  [ACTIONS.CREATED_ROLE]: UserAdd,
  [ACTIONS.UPDATED_ROLE]: UserSettings,
  [ACTIONS.DELETED_ROLE]: UserRemove,
  [ACTIONS.INTEGRATION_CONNECTED]: UserSettings,
  [ACTIONS.INTEGRATION_DISCONNECTED]: UserSettings,
  [ACTIONS.INTEGRATION_DISCONNECTED_BY_PROVIDER]: UserSettings,
  [ACTIONS.CONNECTED_STRIPE_ACCOUNT]: StripeTypeface,
  [ACTIONS.DISCONNECTED_STRIPE_ACCOUNT]: Stripe,
  [ACTIONS.CONNECTED_ZOOM_INTEGRATION]: Zoom,
  [ACTIONS.DISCONNECTED_ZOOM_INTEGRATION]: Zoom,
  [ACTIONS.CONNECTED_CUSTOM_DOMAIN]: CustomDomain,
  [ACTIONS.CREATED_API_KEY]: ApiKeys,
  [ACTIONS.DELETED_API_KEY]: ApiKeys,
  [ACTIONS.UPDATED_API_KEY]: ApiKeys,
};

export const AUDIT_LOGS_PAGE_SIZE = 12;

export const LANGUAGE_OPTIONS_MAP = indexBy(prop("value"), LANGUAGE_OPTIONS);

export const DATE_FORMAT_OPTIONS_MAP = {
  "%m/%d/%Y": "MM/DD/YYYY",
  "%d/%m/%Y": "DD/MM/YYYY",
  "%Y/%m/%d": "YYYY/MM/DD",
};

export const FIELD_NAME_MAP = { organizationRole: "role" };

export const INTEGRATION_ICON_MAP = {
  google_calendar: GoogleCalendar,
  google_meet: GoogleMeet,
  icloud_calendar: Apple,
  outlook: Outlook,
  slack: Slack,
  teams: Teams,
  twilio: Twilio,
  zoom: Zoom,
};

export const INTEGRATION_DISPLAY_NAME_MAP = {
  google_calendar: "Google Calendar",
  google_meet: "Google Meet",
  icloud_calendar: "iCloud Calendar",
  outlook: "Outlook",
  slack: "Slack",
  teams: "Microsoft Teams",
  twilio: "Twilio",
  zoom: "Zoom",
};
